export default __webpack_public_path__ + "9b7afae9b2ab441f4d2682db64172f5c.svg";